import type { Database } from '@/types/supabase';
import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for interacting with your database
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Add some validation to prevent errors if env vars are missing
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing environment variables. Check your .env file.');
}

// Use named export instead of default export to avoid CJS/ESM compatibility issues
export const supabase = createClient<Database>(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    storageKey: 'supabase.auth.token',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
